// DS: C25A
import React from 'react';
import classnames from 'classnames';
import ArrowDownIcon from '@wix/da-ds/pkg/Icons/ArrowDown';
import shortenNumber from '@wix/da-ds/pkg/utils/shortenNumber';
import { PopperDropdownManager, PopperDropdownToggle, PopperDropdownContent } from '@wix/da-ds/pkg/Dropdown/PopperDropdownLayout';
import FolderDropdownDesktopMenu from './FolderDropdownDesktopMenu';
import { IconSize } from '@wix/da-ds/pkg/Icons/IconWrap';
import LoadingIndicator from '@wix/da-ds/pkg/LoadingIndicator';
import s from './FolderDropdownDesktop.scss';
const FolderDropdownDesktop = ({ id, folderNameClassNames, currentFolder, arrowIconSize = IconSize.SMALL, className, usePortal, folders, disabled, setSelectedFolderId, renderToggle, escapeScreenSpace = true, hasMore, fetchMore, isLoading })=>{
    const classNames = classnames(s['root'], 'no-theme-skin', disabled && s['disabled'], className);
    var _currentFolder_totalItemCount, _ref;
    return /*#__PURE__*/ React.createElement("div", {
        className: classNames
    }, /*#__PURE__*/ React.createElement(PopperDropdownManager, {
        isInPopup: true
    }, /*#__PURE__*/ React.createElement(PopperDropdownToggle, {
        className: s['toggle']
    }, renderToggle ? renderToggle({
        currentFolder
    }) : /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement("div", {
        className: classnames(s['selected-folder-name'], folderNameClassNames)
    }, currentFolder && currentFolder.name, /*#__PURE__*/ React.createElement("span", {
        className: s['count']
    }, shortenNumber((_ref = (_currentFolder_totalItemCount = currentFolder === null || currentFolder === void 0 ? void 0 : currentFolder.totalItemCount) !== null && _currentFolder_totalItemCount !== void 0 ? _currentFolder_totalItemCount : currentFolder === null || currentFolder === void 0 ? void 0 : currentFolder.size) !== null && _ref !== void 0 ? _ref : 0))), /*#__PURE__*/ React.createElement(ArrowDownIcon, {
        className: s['caret'],
        size: arrowIconSize
    }))), /*#__PURE__*/ React.createElement(PopperDropdownContent, {
        usePortal: usePortal,
        placement: "bottom-start",
        allowFlip: false
    }, /*#__PURE__*/ React.createElement(FolderDropdownDesktopMenu, {
        id: id,
        folders: folders,
        setSelectedFolderId: setSelectedFolderId,
        currentFolder: currentFolder,
        hasMore: hasMore,
        fetchMore: fetchMore
    }), isLoading && /*#__PURE__*/ React.createElement(LoadingIndicator, {
        coverMode: true,
        view: "llama"
    }))));
};
FolderDropdownDesktop.displayName = 'FolderDropdownDesktop';
export default FolderDropdownDesktop;

//# sourceMappingURL=FolderDropdownDesktop.js.map